module.exports = __webpack_public_path__ + "img/menu_icon_mine.d6984c11.png";